/**
 * Modeled after Avalara "AddressLocationInfo" - https://developer.avalara.com/api-reference/avatax/rest/v2/models/AddressLocationInfo/
 * Called AddressLocationInfo to distinguish from ShippingAddress
 *
 * From Avalara: "you must provide either a valid:
 * - line1 + postal code
 * - postal code
 * - line1 + city + region
 */

import { z } from 'zod';

const addressLocationInfoLine1PostalSchema = z.object({
  line1: z.string(), // e.g. "123 Main St"
  postalCode: z.string(), // e.g. "83702"
});
const addressLocationInfoPostalSchema = z.object({
  postalCode: z.string(), // e.g. "83702"
});
const addressLocationInfoLine1CityRegionSchema = z.object({
  line1: z.string(), // e.g. "123 Main St"
  city: z.string(), // e.g. "Boise"
  region: z.string(), // e.g. "US"
});

// Note that...
// > It validates in order, and returns the first schema that passes, even if others are a better match.
export const addressLocationInfoSchema = z.union([
  addressLocationInfoLine1PostalSchema, // order first so if we have postalCode and line1, zod doesnt assume addressLocationInfoPostalSchema.
  addressLocationInfoPostalSchema,
  addressLocationInfoLine1CityRegionSchema,
]);

export type AddressLocationInfo = z.infer<typeof addressLocationInfoSchema>;
